var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2005 10.3137H10.6739L10.4872 10.1337C11.1405 9.37368 11.5339 8.38701 11.5339 7.31368C11.5339 4.92035 9.59385 2.98035 7.20052 2.98035C4.80719 2.98035 2.86719 4.92035 2.86719 7.31368C2.86719 9.70701 4.80719 11.647 7.20052 11.647C8.27385 11.647 9.26052 11.2537 10.0205 10.6003L10.2005 10.787V11.3137L13.5339 14.6403L14.5272 13.647L11.2005 10.3137ZM7.20052 10.3137C5.54052 10.3137 4.20052 8.97368 4.20052 7.31368C4.20052 5.65368 5.54052 4.31368 7.20052 4.31368C8.86052 4.31368 10.2005 5.65368 10.2005 7.31368C10.2005 8.97368 8.86052 10.3137 7.20052 10.3137Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.4fd627f7fefc1f3570cefc61a7b2dd8e.svg";
export { ForwardRef as ReactComponent };